/* unplugin-vue-components disabled */import script from "./AdsterraNativeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AdsterraNativeBanner.vue?vue&type=script&setup=true&lang=js"

import "./AdsterraNativeBanner.vue?vue&type=style&index=0&id=696400c0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-696400c0"]])

export default __exports__